/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { useQuery, useQueryClient } from "@tanstack/react-query";
//import Carousel from "../Carousel";
import { URL_API } from "../../../config/default";

import "react-responsive-carousel/lib/styles/carousel.min.css";
import AlojamientoPlaceholder from "../Spinner/AlojamientoPlaceholder";
import { myHeaders } from "../../../config/axios";
import { CustomToast } from "../../../utils/custom-toast";
import ExcursionCard from "../excursion-card";
import { Link } from "react-router-dom";
import useMedia from "../../../hooks/useMedia";
import { chunkArray } from "../../../utils/chunkArray";
import { SliderChunk } from "./slider-section";

const TourDestacados = ({ user, favoritos }: any) => {
  const isMobile = useMedia("(max-width: 768px)", false);

  const queryClient = useQueryClient();
  const setFavorito = (excursion: any, favoritos: any) => {
    let check = favoritos.data.filter(
      (f: any) => f.excursion_id == excursion.id
    );
    if (check.length > 0) {
      const requestOptions = {
        method: "DELETE",
        headers: {
          Authorization: myHeaders,
        },
      };

      fetch(`${URL_API}/favorites/${check[0].id}`, requestOptions)
        .then(async (response) => {
          await response.json();
          return CustomToast({
            status: 200,
            msg: "",
            title: "Excursion eliminado de favoritos",
          });
        })
        .catch((error) => console.error(error));


      queryClient.invalidateQueries({
        queryKey: ["favoritos"],
      });
    } else {
      let formData = new FormData();
      formData.append("excursion_id", String(excursion.id));

      const requestOptions = {
        method: "POST",
        body: formData,
        headers: {
          Authorization: myHeaders,
        },
      };

      fetch(`${URL_API}/favorites`, requestOptions)
        .then(async (response) => {
          if (response.ok) {
            await response.json();
            return CustomToast({
              status: 200,
              msg: "",
              title: "Excursion agregado a favoritos",
            });
          } else {
            return CustomToast({
              status: 400,
              msg: "",
              title: "Debes inicisar sesion para generar una lista de favoritos",
            });
          }
        })
        .catch((error) => {
          console.log(error);
        });

      queryClient.invalidateQueries({
        queryKey: ["favoritos"],
      });
    }


  };

  const { isPending, error, data } = useQuery({
    queryKey: ["excursiones-destacados"],
    queryFn: () => {
      return fetch(`${URL_API}/excursions?per_page=50`).then((res) =>
        res.json()
      );
    },
  });

  if (isPending) {
    return (
      <section className="mx-auto px-0 sm:px-[150px]">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-1">
        {[1, 2, 3, 4].map((index) => {
          return <AlojamientoPlaceholder key={index} />;
        })}
      </div></section>
    );
  }

  if (error) return "An error has occurred: " + error.message;


  const chunkSize = isMobile ? 4 : 6;
  const chunkedExcursions = chunkArray(data.data, chunkSize);

  return (
    <section className="mx-auto px-0 sm:px-[150px]">
      <div className="text-center mb-8">
        <Link to="/excursiones">
          <h2 className="text-sm sm:text-3xl font-bold text-[#8B9456] mb-2">
            Tours relacionados
          </h2>
        </Link>
        <p className="text-sm sm:text-lg text-gray-600">
          Los lugares más populares para tu próxima escapada
        </p>
      </div>


      {chunkedExcursions.map((chunk, idx) => (
        <SliderChunk
          key={idx}
          items={chunk}
          renderCard={(destination) => (
            <ExcursionCard
              key={destination.id}
              destination={destination}
              setFavorito={setFavorito}
              favoritos={favoritos}
              user={user}
            />
          )}
        />
      ))}
    </section>
  );
};

export default TourDestacados;
